import React, { useEffect, useMemo, useState } from 'react'
import IPButton from '../../../../../components/IPButton'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import './BankInstallmentReport.scss'
import Translations from '../../../../../translations'
import { translate } from '../../../../../base/localization'
import IPCheckbox from '../../../../../components/IPCheckBox'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { GetWhiteDealerListApi } from '../../../UserOperation/WhiteDealer/services/getWhiteDealerListApi'
import Swal from 'sweetalert2'
import { BankInstallmentReportsRequest, BankInstallmentReportsResponse } from '../../../UserOperation/WhiteDealer/models/models'
import { excelToJSON, exportToXLSX, getDateByTimezoneOffset } from '../../../../../base/utils/dataHelper'
import IPFile from '../../../../../components/IPFile'
import CampaignSelect from '../../../ProductOperation/IyzicoCampaign/CampaignSelect'
import { IyzicoCampaignService } from '../../../ProductOperation/IyzicoCampaign/IyzicoCampaignService'
import { DealerType } from '../../../ProductOperation/IyzicoCampaign/IyzicoCampaignModel'
import { Spinner } from '../../../../../components/Spinner'
import Table from '../../../../../components/Table'
import IPInput from '../../../../../components/IPInput'
import InputCampaign from '../../../../../components/InputCampaign'
import { getCompanyApi } from '../../../components/api'
import { ICompany } from '../../../components/models/models'

function Index(props: BaseComponentWithContextProps) {
  const t = translate(Translations)
  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const [showFilterRow, setShowFilterRow] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [bankInstallmentReports, setBankInstallmentReports] = useState<BankInstallmentReportsResponse[]>([])
  const [filteredList, setFilteredList] = useState<BankInstallmentReportsResponse[]>([])
  const [campaignSelectOptions, setCampaignSelectOptions] = useState<ISelectOption[]>([])
  const [campaignSelectOption, setCampaignSelectOption] = useState<ISelectOption[]>([])
  const [bankSelectOptions, setBankSelectOptions] = useState<ISelectOption[]>([])
  const [bankSelectOption, setBankSelectOption] = useState<any>()
  const [dealerFilter, setDealerFilter] = useState('')
  const [companyListOptions, setCompanyList] = useState<ISelectOption[]>([])

  const paymentTypeOptions: ISelectOption[] = [
    { label: 'Hepsi', value: 0 },
    { label: 'Avantaj', value: 1 },
    { label: 'Fırsat', value: 2 },
  ]
  const [paymentTypeValue, setPaymentTypeValue] = useState<ISelectOption>(paymentTypeOptions[0])
  const [companyListValue, setCompanyListValue] = useState<ISelectOption>({ label: 'Index Grup', value: 0 })

  const filterState: BankInstallmentReportsRequest = {
    StartDate: inititalStartDate,
    EndDate: new Date(),
    BankName: '',
    PaymentType: 0,
    CompanyType: 0,
    DealerCodes: [],
    DealerSubTypes: [],
    IsDealerGroup: false,
    IsCompanyGroup: false,
    IsLimitTermsNameGroup: false,
  }
  const [filters, setFilters] = useState<BankInstallmentReportsRequest>(filterState)

  function updateFilters(prop, val) {
    setFilters(prev => ({ ...prev, [prop]: val }))
  }

  //#region DealerCodes
  const [dealerCodeValue, setDealerCodeValue] = useState<ISelectOption[] | null>(null)
  const [dealerSubTypeValue, setDealerSubTypeValue] = useState<ISelectOption[] | null>(null)
  const [IsDealerListInclude, setIsDealerListInclude] = useState<boolean>(true)
  const [IsDealerSubTypeInclude, setIsDealerSubTypeInclude] = useState<boolean>(true)

  // const getDealerCodes = async () => {
  //   const res = await new IyzicoCampaignService({}).getDealerCodes()
  //   if (res) {
  //     const dealerCodeList: any = []

  //     res.forEach((item: any) => {
  //       item.SapCode && dealerCodeList.push({ value: item.SapCode, label: item.SapCode.toString().replace('0000', '') })
  //     })

  //     return dealerCodeList
  //   }
  // }


  useEffect(() => {
    getCompanies()
  }, [])

  const getCompanies = async () => {
    try {
      const companyList: ICompany[] = await getCompanyApi()
      const companiesOptions: ISelectOption[] = [
        { label: 'Index Grup', value: 0 },
        ...companyList.map(company => ({
          label: company.Name,
          value: company.Code,
        }))
      ]
      setCompanyList(companiesOptions)
    } catch (err) {
      console.log('Fetch Companies Error:', err)
    }
  }



  const getDealerTypes = async () => {
    const res = await new IyzicoCampaignService({}).getDealerTypes()
    if (res) {
      const dealerTypeList: ISelectOption[] = []

      res.forEach((item: DealerType) => {
        item && dealerTypeList.push({ value: item.MusteriGrubu, label: item.MusteriGrubuAciklama })
      })

      return dealerTypeList
    }
  }
  const getDealerSubTypes = async () => {
    const res = await new IyzicoCampaignService({}).getSubTypes()
    if (!res) return []
    return res.map(item => ({ value: item, label: item }))
  }
  const [optionList, setOptionList] = useState<any>({
    //dealerCodeOptions: [],
    dealerTypeOptions: [],
    dealerSubTypeOptions: [],
    bankOptions: [],
  })
  enum CariListType {
    CariCode,
    CariType,
    CariAltType,
  }
  const [selectedDealerList, setSelectedDealerList] = useState(CariListType.CariCode)
  const selectDealer = (takenState, takenEnum) => {
    return takenState === takenEnum ? 'active' : ''
  }

  const setDealerCodes = (dealerCodes, optionArr, updateFunc, type) => {
    if (type === 'DealerCode') {
      const codeData = dealerCodes.map(item => ({
        label: String(item.DealerCode),
        value: String(item.DealerCode),
      }))

      let list: { label: string; value: string }[] = []

      codeData.forEach(codeItem => {
        if (!dealerCodeValue?.some((item: any) => item.label === String(codeItem.label))) {
          list.push(codeItem)
        }
      })
      const newData = dealerCodeValue ? [...dealerCodeValue, ...list] : list
      const uniqueList = newData.filter((item, index, self) => {
        return index === self.findIndex(i => i.label === item.label)
      })
      setDealerCodeValue(uniqueList)
      updateFilters(
        'DealerCodes',
        uniqueList.map(item => item.value)
      )
    } else {
      const list: any = []
      const codeData: any = []

      dealerCodes.forEach(item => {
        const codes: any = optionArr.find((code: any) => {
          if (item.DealerCode.length === 6) {
            return code.label === item.DealerCode
          } else {
            return code.label === '0000' + item.DealerCode
          }
        })
        if (codes === undefined) codeData.push(item.DealerCode)
        else list.push(codes)
      })

      if (type === 'DealerSubType') {
        updateFilters(
          'DealerSubTypes',
          list.map(item => item.value)
        )
      }

      if (codeData.length === 0) {
        return updateFunc(list)
      }

      Swal.fire({
        icon: 'question',
        title: `${codeData.map(dt => dt)} bu cariler bulunamadı. Yeniden yüklemek ister misiniz?`,
        showConfirmButton: true,
        allowOutsideClick: false,
        showDenyButton: true,
        confirmButtonText: 'Evet',
        denyButtonText: 'Hayır',
      }).then(async result => {
        if (result.isConfirmed) return
        updateFunc(list)
      })
    }
  }

  const handleFiles = async (files: File[], type: 'DealerCode' | 'DealerType' | 'DealerSubType') => {
    const dealerCodes: any = await excelToJSON(files[0])

    if (type === 'DealerCode') {
      setDealerCodes(dealerCodes[0], optionList.dealerCodeOptions, setDealerCodeValue, type)
      return
    }
    if (type === 'DealerSubType') {
      setDealerCodes(dealerCodes[0], optionList.dealerSubTypeOptions, setDealerSubTypeValue, type)
    }
  }
  //#endregion

  const [bankValue, setBankValue] = useState<ISelectOption | null>(null)
  async function GetBanks() {
    try {
      const res = await new GetWhiteDealerListApi({}).getBanks()
      if (res) {
        const banks = res.map(x => ({ label: x.BankName, value: x.BankID }))
        if (!banks) return []
        return banks
      }
    } catch (err: any) {
      console.error(err)
    }
  }

  useEffect(() => {
    props.showLoading()
    Promise.all([getDealerTypes(), getDealerSubTypes(), GetBanks()])
      .then((data: any) => {
        const [dealerTypeOptions, dealerSubTypeOptions, bankOptions] = data

        setOptionList({
          dealerTypeOptions,
          dealerSubTypeOptions,
          bankOptions,
        })
        props.hideLoading()
      })
      .catch(() => {
        props.hideLoading()
      })
  }, [])

  const dateValid = () => {
    const result = filters.EndDate.getTime() - filters.StartDate.getTime()
    if (result < 60000) {
      Swal.fire('Bitiş tarihi başlangıç tarihinden önce olamaz.')
      updateFilters('EndDate', new Date())
    }
  }

  //#region GetTransactionList
  async function getTransactionList() {
    const req = {
      ...filters,
      StartDate: getDateByTimezoneOffset(startDate),
      EndDate: getDateByTimezoneOffset(endDate),
      IsDealerListInclude: IsDealerListInclude,
      IsDealerSubTypeInclude: IsDealerSubTypeInclude,
    }
    req.DealerCodes = req.DealerCodes.map(a => '0000' + a)
    props.showLoading()

    try {
      const res = await new GetWhiteDealerListApi({}).bankInstallmentReports(req)
      if (res) {
        const uniqueBankLabels = {}
        const uniqueTermsLabels = {}

        if (filters.IsLimitTermsNameGroup) {
          // Extract options for CampaignSelect and BankSelect
          const campaignOptions = res.map(x => ({
            value: x.LimitTermsName,
            label: x.LimitTermsName.toUpperCase(),
          }))
          setCampaignSelectOptions(
            campaignOptions.filter(option => {
              if (!uniqueTermsLabels[option.label]) {
                uniqueTermsLabels[option.label] = true
                return true
              }
              return false
            })
          )
        }

        if (!bankValue) {
          const bankOptions = res.map(x => ({
            value: x.BankName,
            label: x.BankName.toUpperCase(),
          }))
          setBankSelectOptions(
            bankOptions.filter(option => {
              if (!uniqueBankLabels[option.label]) {
                uniqueBankLabels[option.label] = true
                return true
              }
              return false
            })
          )
        }
        setBankInstallmentReports(res)
        setFilteredList(res)
        setShowFilterRow(true)
      }
      props.hideLoading()
    } catch (err: any) {
      props.hideLoading()
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
      })
      setBankInstallmentReports([])
      setFilteredList([])
    }
  }
  //#endregion

  const formatCurrency = value => {
    return (
      value
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ₺'
    )
  }

  const formatCurrencyExcel = value => {
    return value.toFixed(2).replace('.', ',')
  }

  //#region Table Data
  const tableColumns = useMemo(() => {
    const currencyColumn = {
      Cell: ({ value }) => {
        if (typeof value === 'number') {
          return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺'
        }
        return value
      },
    }
    const withoutDealer = [
      {
        Header: 'Şirket',
        accessor: 'Company',
      },
      {
        Header: 'Banka',
        accessor: 'BankName',
      },
      // Conditionally add LimitTermsName column
      ...(filters.IsLimitTermsNameGroup
        ? [
          {
            Header: 'Kampanya Adı',
            accessor: 'LimitTermsName',
          },
        ]
        : []),
      {
        Header: 'Peşin',
        accessor: 'OdemePesin',
        ...currencyColumn,
      },
      {
        Header: '2 Taksit',
        accessor: 'OdemeIkiTaksit',
        ...currencyColumn,
      },
      {
        Header: '3 Taksit',
        accessor: 'OdemeUcTaksit',
        ...currencyColumn,
      },
      {
        Header: '4 Taksit',
        accessor: 'OdemeDortTaksit',
        ...currencyColumn,
      },
      {
        Header: '5 Taksit',
        accessor: 'OdemeBesTaksit',
        ...currencyColumn,
      },
      {
        Header: '6 Taksit',
        accessor: 'OdemeAltiTaksit',
        ...currencyColumn,
      },
      {
        Header: '9 Taksit',
        accessor: 'OdemeDokuzTaksit',
        ...currencyColumn,
      },
      {
        Header: '12 Taksit',
        accessor: 'OdemeOnIkiTaksit',
        ...currencyColumn,
      },
      {
        Header: '15 Taksit',
        accessor: 'OdemeOnBesTaksit',
        ...currencyColumn,
      },
      {
        Header: '18 Taksit',
        accessor: 'OdemeOnSekizTaksit',
        ...currencyColumn,
      },
      {
        Header: '24 Taksit',
        accessor: 'OdemeYirmiDortTaksit',
        ...currencyColumn,
      },
      {
        Header: 'Sipariş Numarası',
        accessor: 'OrderNumber',
      },
    ]
    if (filters.IsDealerGroup) {
      return [
        {
          Header: 'Cari',
          accessor: 'SapCode',
        },
        {
          Header: 'Cari Ünvanı',
          accessor: 'DealerName',
        },
        ...withoutDealer,
      ]
    }
    return withoutDealer
  }, [filteredList])

  const tableData = useMemo(
    () =>
      filteredList?.length > 0 &&
      filteredList?.map(p => ({
        Company: companyListOptions.find(a => a.value === p.Company)?.label || 'Index Grup',
        SapCode: p.SapCode && p.SapCode.replace('0000', ''),
        DealerName: p.DealerName,
        BankName: p.BankName,
        ...(filters.IsLimitTermsNameGroup && { LimitTermsName: p.LimitTermsName }),
        OdemeAltiTaksit: p.OdemeAltiTaksit,
        OdemeBesTaksit: p.OdemeBesTaksit,
        OdemeDokuzTaksit: p.OdemeDokuzTaksit,
        OdemeDortTaksit: p.OdemeDortTaksit,
        OdemeIkiTaksit: p.OdemeIkiTaksit,
        OdemeOnBesTaksit: p.OdemeOnBesTaksit,
        OdemeOnIkiTaksit: p.OdemeOnIkiTaksit,
        OdemeOnSekizTaksit: p.OdemeOnSekizTaksit,
        OdemePesin: p.OdemePesin,
        OdemeUcTaksit: p.OdemeUcTaksit,
        OdemeYirmiDortTaksit: p.OdemeYirmiDortTaksit,
        OrderNumber: p.OrderNumber,
      })),
    [filteredList, companyListOptions]
  )
  //#endregion

  //#region Detaylı Süzme fonksiyonu
  const filterList = () => {
    const filterConditions: ((item: BankInstallmentReportsResponse) => boolean)[] = []

    if (campaignSelectOption.length > 0) {
      filterConditions.push(b => {
        const selectedLabels = campaignSelectOption.map(option => option.label.toUpperCase())
        return selectedLabels.includes(b.LimitTermsName.toUpperCase())
      })
    }

    if (bankSelectOption) {
      filterConditions.push(b => b.BankName.toUpperCase() === bankSelectOption.label)
    }

    if (dealerFilter) {
      filterConditions.push(b => b.SapCode.includes(dealerFilter))
    }

    let filteredData: BankInstallmentReportsResponse[] = bankInstallmentReports

    if (filterConditions.length > 0) {
      filteredData = filteredData.filter(item => {
        return filterConditions.every(condition => condition(item))
      })
    }
    setFilteredList(filteredData)
  }
  //#endregion

  //#region Excel Export

  const excelButton = async () => {
    try {
      const data: any[] = []
      if (filteredList && filteredList.length > 0) {
        filteredList.map(p => {
          const rowData: any = {}

          if (filters.IsDealerGroup) {
            rowData['SAP Bayi Kodu'] = p.SapCode ? p.SapCode.replace('0000', '') : ''
            rowData['Cari Ünvanı'] = p.DealerName
          }

          let companyValue = 'Index Grup' // Default value

          companyListOptions.find(a => a.value === p.Company)?.label ? companyValue = companyListOptions.find(a => a.value === p.Company)?.label : companyValue = 'Index Grup'


          rowData['Şirket'] = companyValue
          rowData['Banka Adı'] = p.BankName

          // Conditionally add LimitTermsName column
          if (filters.IsLimitTermsNameGroup) {
            rowData['Kampanya Adı'] = p.LimitTermsName || ''
          }

          rowData['Peşin'] = formatCurrencyExcel(p.OdemePesin)
          rowData['2 Taksit'] = formatCurrencyExcel(p.OdemeIkiTaksit)
          rowData['3 Taksit'] = formatCurrencyExcel(p.OdemeUcTaksit)
          rowData['4 Taksit'] = formatCurrencyExcel(p.OdemeDortTaksit)
          rowData['5 Taksit'] = formatCurrencyExcel(p.OdemeBesTaksit)
          rowData['6 Taksit'] = formatCurrencyExcel(p.OdemeAltiTaksit)
          rowData['9 Taksit'] = formatCurrencyExcel(p.OdemeDokuzTaksit)
          rowData['12 Taksit'] = formatCurrencyExcel(p.OdemeOnIkiTaksit)
          rowData['15 Taksit'] = formatCurrencyExcel(p.OdemeOnBesTaksit)
          rowData['18 Taksit'] = formatCurrencyExcel(p.OdemeOnSekizTaksit)
          rowData['24 Taksit'] = formatCurrencyExcel(p.OdemeYirmiDortTaksit)
          rowData['Sipariş Numarası'] = p.OrderNumber

          data.push(rowData)
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Excele atılacak veri bulunmamaktadır.',
          allowOutsideClick: true,
          backdrop: true,
        })
        return
      }

      exportToXLSX(data, 'Banka Taksit Raporu')
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  //#endregion

  const [inputValue, setInputValue] = useState('')

  const handleInputChange = event => {
    setInputValue(event.target.value)
  }

  const handleInputKeyPress = event => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleAddValue()
    }
  }

  const handleAddValue = () => {
    if (inputValue.trim() !== '') {
      const words = inputValue.split(' ')
      let dealerList: { label: string; value: string }[] = []
      words.forEach((word: any) => {
        if (!dealerCodeValue?.some((item: any) => item.label === word)) {
          const newItem = { label: word, value: word }
          dealerList.push(newItem)
        }
      })

      const newData = dealerCodeValue ? [...dealerCodeValue, ...dealerList] : dealerList
      const uniqueList = newData.filter((item, index, self) => {
        return index === self.findIndex(i => i.label === item.label)
      })
      setDealerCodeValue(uniqueList)
      updateFilters(
        'DealerCodes',
        uniqueList.map(item => item.value)
      )
      setInputValue('')
    }
  }

  return (
    <>
      <div className='container whiteDealer'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <span className='h4'>Banka Taksit Raporu</span>
            <div className='d-flex align-items-center'>
              <span>Excel: </span>
              <button
                type='button'
                style={{
                  border: '1px solid #2e7d32',
                  borderRadius: 0,
                  width: '29px',
                  height: '29px',
                  backgroundColor: 'white',
                  margin: '0 10px',
                }}
                onClick={excelButton}
                className='btn text-capitalize background-white-important d-flex align-items-center'
              >
                <i
                  className='fas fa-file-excel'
                  style={{
                    marginLeft: '-6px',
                    fontSize: '18px',
                    color: '#2e7d32',
                  }}
                ></i>
              </button>
            </div>
          </div>
          <div className='card-body'>
            <form>
              <div className='row'>
                <div className='col-12 col-lg-3 mb-4'>
                  <label htmlFor='bank' className='form-label'></label>
                  <InputCampaign
                    type='datetime-local'
                    id='StartDate'
                    name='StartDate'
                    label={'Yayın Başlangıç Tarihi'}
                    value={toDateTimeLocal(startDate)}
                    onChange={e => getDate(e.target.value, 'Start')}
                    isActive
                  />
                </div>
                <div className='col-12 col-lg-3 mb-4'>
                  <label htmlFor='bank' className='form-label'></label>
                  <InputCampaign
                    type='datetime-local'
                    id='EndDate'
                    name='EndDate'
                    label={'Yayın Bitiş Tarihi'}
                    value={toDateTimeLocal(endDate)}
                    onChange={e => getDate(e.target.value, 'End')}
                    onBlur={dateValid}
                    isActive
                  />
                </div>
                <div className='col-12 col-lg-3 mb-4'>
                  <label htmlFor='bank' className='form-label'>
                    Banka
                  </label>
                  <IPSelectBox
                    isClearable
                    id='Bank'
                    options={optionList.bankOptions}
                    value={bankValue}
                    onChangeSingle={option => {
                      setBankValue(option)
                      if (option) updateFilters('BankName', option.label)
                      else updateFilters('BankName', '')
                    }}
                  />
                </div>
                <div className='col-12 col-lg-3 mb-4'>
                  <label htmlFor='sirket' className='form-label'>
                    Şirket
                  </label>
                  <IPSelectBox
                    id='Companies'
                    name='Companies'
                    options={companyListOptions}
                    value={companyListValue}
                    onChangeSingle={option => {
                      setCompanyListValue(option)
                      updateFilters('CompanyType', option.value)
                    }}
                  />
                </div>
                <div className='col-12 col-lg-6'>
                  <div className='row'>
                    <label htmlFor='tip' className='form-label'>
                      Avantaj/Fırsat POS
                    </label>
                    <IPSelectBox
                      id='Types'
                      name='Types'
                      options={paymentTypeOptions}
                      value={paymentTypeValue}
                      onChangeSingle={option => {
                        setPaymentTypeValue(option)
                        updateFilters('PaymentType', option.value)
                      }}
                    />
                  </div>
                  <div className='row mt-5'>
                    <div className='col-lg-5'>
                      <IPCheckbox
                        name='Active1'
                        label='Cariye Göre Grupla'
                        checked={filters.IsDealerGroup}
                        onCheckedChange={checked => {
                          updateFilters('IsDealerGroup', checked)
                          setShowFilterRow(false)
                        }}
                      />
                      {companyListValue.label === 'Index Grup' && (
                        <IPCheckbox
                          name='Active2'
                          label='Şirkete Göre Grupla'
                          checked={filters.IsCompanyGroup}
                          onCheckedChange={checked => {
                            updateFilters('IsCompanyGroup', checked)
                            setShowFilterRow(false)
                          }}
                        />
                      )}
                      <IPCheckbox
                        name='Active3'
                        label='Kampanyaya Göre Grupla'
                        checked={filters.IsLimitTermsNameGroup}
                        onCheckedChange={checked => {
                          updateFilters('IsLimitTermsNameGroup', checked)
                          setShowFilterRow(false)
                        }}
                      />
                    </div>
                    <div className='col-lg-3'>
                      <IPButton type='button' className='btn btn-success' text='Excele Aktar' onClick={excelButton} />
                    </div>
                    <div className='col-lg-3'>
                      <IPButton
                        type='button'
                        className='btn btn-danger'
                        text='Göster'
                        onClick={() => {
                          getTransactionList()
                          setBankSelectOption(null)
                          setCampaignSelectOption([])
                          setDealerFilter('')
                        }}
                        style={{ width: 80 }}
                      />
                    </div>
                  </div>

                  {showFilterRow && (
                    <>
                      <div
                        className='detailFilter'
                        style={{
                          marginTop: '10px',
                          border: '2px solid #9c9cf1',
                          padding: '10px 5px 0px 5px',
                        }}
                      >
                        <div className='row justify-content-center'>
                          {filters.IsLimitTermsNameGroup && (
                            <div className='form-group col-md-8'>
                              <IPSelectBox
                                isClearable
                                isMulti
                                isCreatableSelect
                                isSearchable
                                placeholder='Kampanya Seçiniz...'
                                options={campaignSelectOptions}
                                value={campaignSelectOption}
                                onChangeMulti={option => {
                                  setCampaignSelectOption(option)
                                }}
                              />
                            </div>
                          )}

                          {!bankValue && (
                            <div className='form-group col-md-4'>
                              <IPSelectBox
                                isClearable
                                placeholder='Banka Seçiniz...'
                                options={bankSelectOptions}
                                value={bankSelectOption}
                                onChangeSingle={option => {
                                  setBankSelectOption(option)
                                }}
                              />
                            </div>
                          )}
                          {filters.IsDealerGroup && (
                            <div className='form-group col-md-3'>
                              <IPInput
                                type='text'
                                id='Title'
                                className='form-control'
                                name='Title'
                                placeholder='Cari Kodu...'
                                onChange={e => setDealerFilter(e.target.value)}
                                value={dealerFilter}
                                onKeyDown={e => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault()
                                    filterList()
                                  }
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className='row justify-content-center'>
                          <div className='form-group col-md-3'>
                            <IPButton
                              type='button'
                              className='btn btn-primary'
                              text='Detaylı Süz'
                              onClick={filterList}
                              style={{ height: '40px' }}
                            />
                          </div>
                          <div className='form-group col-md-3'>
                            <IPButton
                              type='button'
                              className='btn btn-success'
                              text={t(
                                'pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.exportToExcel'
                              )}
                              onClick={excelButton}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div className='col-12 col-lg-6'>
                  <div className='leftContainer mb-5'>
                    <div>
                      <a className='campaignExcelBtn' href='/assetWeb/docs/dealer-codes-example.xlsx' target='_blank'>
                        Örnek Excel
                      </a>
                      <div className='listBtnGroup justify-content-between'>
                        <IPButton
                          className={`listCariBtn ${selectDealer(selectedDealerList, CariListType.CariCode)}`}
                          text={`Cari Kodu Listesi ${dealerCodeValue && dealerCodeValue.length > 0 ? '✅' : ''}`}
                          onClick={() => setSelectedDealerList(CariListType.CariCode)}
                        />
                        {/* <IPButton
                      className={`listCariBtn ${selectDealer(selectedDealerList, CariListType.CariType)}`}
                      text={`Cari Tipi Listesi ${dealerTypeValue && dealerTypeValue.length > 0 ? '✅' : ''}`}
                      onClick={() => setSelectedDealerList(CariListType.CariType)}
                    /> */}
                        <IPButton
                          className={`listCariBtn ${selectDealer(selectedDealerList, CariListType.CariAltType)}`}
                          text={`Cari Alt Tipi Listesi ${dealerSubTypeValue && dealerSubTypeValue.length > 0 ? '✅' : ''
                            }`}
                          onClick={() => setSelectedDealerList(CariListType.CariAltType)}
                        />
                      </div>
                    </div>

                    <div className='p-0 m-0'>
                      <div
                        className={`cariFilterTextAreaWrap ${selectDealer(selectedDealerList, CariListType.CariCode)}`}
                      >
                        <div className='topBtnGroup d-flex justify-content-center align-items-center mb-4'>
                          <IPFile
                            id='FileInputDealerCode'
                            multiple={false}
                            handleFiles={e => handleFiles(e, 'DealerCode')}
                            removeAfterSelect={true}
                            className='campaignFileInput'
                            label="Excel'den Yükle"
                          />
                          <IPButton
                            text={'Dahil'}
                            className={`btnIncluded ${IsDealerListInclude ? 'active' : ''}`}
                            onClick={() => setIsDealerListInclude(true)}
                          />
                          <IPButton
                            text={'Hariç'}
                            className={`btnExcept ${!IsDealerListInclude ? 'active' : ''}`}
                            onClick={() => setIsDealerListInclude(false)}
                          />
                        </div>
                        <CampaignSelect
                          placeholder={'Cari Kod Listesi'}
                          height={180}
                          //options={optionList.dealerCodeOptions}
                          onChangeMulti={options => {
                            setDealerCodeValue(options)
                            updateFilters(
                              'DealerCodes',
                              options.map(item => item.value)
                            )
                          }}
                          value={dealerCodeValue}
                        />
                        <input
                          type='text'
                          placeholder='Cari kodu yazın'
                          value={inputValue}
                          onChange={handleInputChange}
                          onKeyPress={handleInputKeyPress}
                        />
                      </div>

                      <div
                        className={`cariFilterTextAreaWrap ${selectDealer(
                          selectedDealerList,
                          CariListType.CariAltType
                        )}`}
                      >
                        <div className='topBtnGroup d-flex justify-content-center align-items-center mb-4'>
                          <div className='btns d-flex'>
                            <IPFile
                              id='FileInputDealerSubType'
                              multiple={false}
                              handleFiles={e => handleFiles(e, 'DealerSubType')}
                              removeAfterSelect={true}
                              className='campaignFileInput'
                              label="Excel'den Yükle"
                            />
                            <IPButton
                              text={'Dahil'}
                              className={`btnIncluded ${IsDealerSubTypeInclude ? 'active' : ''}`}
                              onClick={() => setIsDealerSubTypeInclude(true)}
                            />
                            <IPButton
                              text={'Hariç'}
                              className={`btnExcept ${!IsDealerSubTypeInclude ? 'active' : ''}`}
                              onClick={() => setIsDealerSubTypeInclude(false)}
                            />
                          </div>
                        </div>
                        <CampaignSelect
                          placeholder={'Cari Alt Tipi Listesi'}
                          height={180}
                          options={optionList.dealerSubTypeOptions}
                          onChangeMulti={options => {
                            setDealerSubTypeValue(options)
                            updateFilters(
                              'DealerSubTypes',
                              options.map(item => item.value)
                            )
                          }}
                          value={dealerSubTypeValue}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className='row mt-4'>
              <div className='col-12 col-lg-6'>
                <div className='row'>
                  <div className='col-6'>
                    <IPButton
                      type='button'
                      className='btn btn-success'
                      text={t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.exportToExcel')}
                    />
                  </div>
                  <div className='col-6'>
                    <IPButton
                      type='button'
                      className='btn btn-success'
                      text={t('pages.admin.freeAndOpportunityPosOperation.bank.bankInstallmentReport.show')}
                      onClick={getWhiteDealerList}
                    />
                  </div>
                </div>
              </div>
            </div> */}
            </form>

            {filteredList && filteredList.length > 0 && (
              <div className='row'>
                <div className='col-lg-12'>
                  <div id='datatable_wrapper' className='dataTables_wrapper dt-bootstrap4'>
                    <div className='row'>
                      <div className='col-sm-12'>
                        <Table columns={tableColumns} data={tableData} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Spinner loading={isLoading} />
    </>
  )
}

export default componentWithContext(Index)
